import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHome = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 10,
		d: "M16 2 1.223 17.285a.125.125 0 0 0 .087.215H5V31h7.5v-8.5h7V31H27V17.5h3.691a.125.125 0 0 0 .087-.215z"
	})
});
export default SvgIconHome;
